export const getExpenseCategoryList = state => {
    return state.list
}

export const getExpenseCategoryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseCategory/getters.js